<template>
  <div class="tableWithPerPageSelection">
    <div class="entete border-entete">
      <div class="level">
        <div class="level-left">
          <div class="columns is-gapless">
            <div class="column">
              <h1 class="title is-size-3">{{ $t('reseauTempo.title') }}</h1>
              <breadcrumb :breadcrumb="breadcrumb"/>
            </div>
          </div>
        </div>
        <div class="level-right"
             v-if="!isPlanning">
          <div class="buttons">
            <a @click="annuler()"
               class="button">
              {{ $t('reseauTempo.action.back')}}
            </a>
          </div>
        </div>
      </div>
    </div>
    <div class="columns level mgb-0 mgl-0">
      <jumpWeekDatePicker
        v-model="dateDebut"
        :nb-jour-a-sauter="datePlanning.days"
        @input="updateDate"
      />
      <div class="column is-narrow mgt-10px">
        <form @submit.prevent="recherche()">
          <b-input :placeholder="$t('general.placeHolder.search')"
                    type="search"
                    v-model="briefStocke.auto"
                    icon="magnify">
          </b-input>
        </form>
      </div>
      <div class="column is-narrow mgt-10px pdl-5px pdr-0">
        <b-field>
          <b-select v-model="afficherFacesAffectees" expanded>
            <option :value="false">
              {{$t('reseauTempo.action.facesPrevus')}}
            </option>
            <option :value="true">
              {{$t('reseauTempo.action.facesAffecteesAuReseau')}}
            </option>
          </b-select>
        </b-field>
      </div>
      <div class="mgl-10px has-text-default column is-2-tablet is-2 mgt-10px pdh-0">
        <b-checkbox :value="afficherAnnonceur" class="is-flex mg-auto"
                    @input="setAfficherAnnonceur">
          {{ $t('reseauTempo.afficherAnnonceur') }}
        </b-checkbox>
      </div>
      <div class="level-right column mgt-10px pdh-0">
        <div class="column is-pulled-right">
          <legende-reseau-tempo></legende-reseau-tempo>
          <exportExcelButton
            :perm="permPlanning.exporter"
            class="is-inline-block mgl-2"
            in-progress/>
          <parametrage-table class="mgl-10px"
            :reference-table="referenceTable"
            @endLoadParamtre="startArrayRendering = true">
          </parametrage-table>
        </div>
      </div>
    </div>
    <div class="columns">
      <div class="column is-4">
        <div class="has-text-default mgt-10px"
             v-if="briefStocke.produitLocation && briefStocke.produitLocation.libelle">
          {{$t('reseauTempo.location',
            { location: briefStocke.produitLocation.libelle
                + (briefStocke.produitLocation.reference ?
                  ' - ' + briefStocke.produitLocation.reference : '')}
          )}}
        </div>
      </div>
      <div class="column is-4">
        <div class="columns is-centered">
        <div class="column is-narrow pdr-0"
             v-if="isPlanning || commandeCourante && commandeCourante.type === TYPE_DEVIS">
          <div class="button" @click='setBoutonSelection(!boutonSelection)'
               :class="{'button-border-primary': boutonSelection}">
            <b-icon icon="circle" size="is-small" type="is-success"></b-icon>
            <span class="is-size-7"> {{$t('reseauTempo.action.selection')}} </span>
          </div>
        </div>
        <div class="column is-narrow pdr-0"
             v-if="isPlanning || commandeCourante && commandeCourante.type === TYPE_DEVIS">
          <div class="button" @click='setBoutonBloquer({boutonBloquer: !boutonBloquer,
              isPlanning: isPlanning})'
               :class="{'button-border-primary': boutonBloquer}">
            <b-icon icon="circle" size="is-small" type="is-selectionBloque"></b-icon>
            <span class="is-size-7"> {{$t('reseauTempo.action.bloquer')}} </span>
          </div>
        </div>
        <div class="column is-narrow"
             v-if="isPlanning || commandeCourante && commandeCourante.type === TYPE_DEVIS">
          <div class="button" @click='setBoutonOption({boutonOption: !boutonOption,
               isPlanning: isPlanning})'
               :class="{'button-border-primary': boutonOption}">
            <b-icon icon="circle" size="is-small" type="is-selectionOption"></b-icon>
            <span class="is-size-7"> {{$t('reseauTempo.action.option')}} </span>
          </div>
        </div>
      </div>
      </div>
      <div class="column is-4">
        <div class="columns is-pulled-right">
        <div class="column is-narrow pdr-0">
          <button class="button" @click='visualisationBrief = !visualisationBrief'>
            <b-icon icon="filter-variant" size="is-small" type="is-default"></b-icon>
            <span class="is-size-7">{{$t('reseauTempo.myBrief')}}</span>
          </button>
          <div class="info-circle-right background-primary is-pulled-right"
               :class="{'is-invisible': nombreFiltre === 0}">
            <span class="inside-circle">{{ nombreFiltre }}</span>
          </div>
        </div>
        <div class="column is-narrow pdl-0"
             :class="{'pdr-0': panier.length > 0}">
          <button class="button" @click='visualisationPanier = !visualisationPanier'>
            <b-icon icon="cart-outline" size="is-small" type="is-default"></b-icon>
            <span class="is-size-7" v-if="panier && returnValeurPanier === 0">
                {{$t('reseauTempo.panier')}}
                </span>
            <span class="is-size-7" v-else>{{ returnValeurPanier | formatDevise}}</span>
          </button>
          <div class="info-circle-right background-danger is-pulled-right"
               v-if="panier.length > 0">
            <span class="inside-circle">{{ panier.length > 9 ? '9+' : panier.length }}</span>
          </div>
        </div>
        </div>
      </div>
    </div>
    <v-server-table :columns="columns" :options="options" @loaded="finLoading"
                    v-if="startArrayRendering && mountedLoadingEnd"
                    @loading="debutLoading" :ref="referenceTable">
      <template slot='afterTable'>
        <table-items-in-view :perPage="resultPerPage"
                             @input="$refs[referenceTable].setLimit($event)"/>
      </template>
      <div slot="reference" slot-scope="props">
        <b-tooltip :label="props.row.reference" position="is-right">
          <div class="ellipsis">
            {{ props.row.reference }}
          </div>
        </b-tooltip>
      </div>
      <div slot="libelle" slot-scope="props">
        <b-tooltip :label="props.row.libelle" position="is-right">
          <router-link-blank
            :to="{ name: 'c.bodac.catalogue-reseau',
                            params: {id: props.row.id}}"
            class="ellipsis"
            :message="props.row.libelle"></router-link-blank>
        </b-tooltip>
      </div>
      <div slot="agence" slot-scope="props" class="ellipsis">
        {{ getAgenceLibelle(props.row.produitReseau.agenceId) }}
      </div>
      <div slot="societe" slot-scope="props" class="ellipsis">
        {{ getLibelleSociete(props.row.supportCommercial.societeId) }}
      </div>
      <template slot="planning" slot-scope="{ row, index }">
        <planning-semaine
          :key="row.id"
          :data="row"
          :index="index"/>
      </template>
    </v-server-table>
    <transition name="custom-classes-transition"
                enter-active-class="animate__animated animate__slideInRight"
                leave-active-class="animate__animated animate__slideOutRight" :duration="10"
                v-if="visualisationBrief || visualisationPanier">
      <div class="componentBrief">
        <brief-planning-reseau-tempo v-if="visualisationBrief"
                                     :produitsLocation="produitsLocation"
                                     @toggleBrief="visualisationBrief = !visualisationBrief"
                                     @appliquerBrief="recherche()"/>
        <panier-planning-reseau-tempo
          :canMakeReseauPerso="canMakeReseauPerso"
          @togglePanier="visualisationPanier = !visualisationPanier"
          @ajouterLigneToCommande="addLigneInDevisCommande"
          v-if="visualisationPanier"/>
      </div>
    </transition>
  </div>
</template>

<script>

import cloneDeep from 'lodash/cloneDeep';
import moment from 'moment';
import { createNamespacedHelpers } from 'vuex';
import breadcrumb from '@/components/general/breadcrumb';
import { PLANNING } from '@/configuration/permissionsBodacConf';
import {
  NO_PAGINATION,
  NO_PER_PAGE_VALUE,
  RESULTS_PER_PAGE_PLANNING,
  SORT_ICON,
  TEXTS,
} from '@/configuration/clientTableConf';
import { ROUTE_ALLOWED_WITHOUT_CLEAN_STORE } from '@/configuration/planning/planningConf';
import * as typesCommande from '@/store/modules/commande-mutation-type';
import * as typesProduitReseauTempo from '@/store/modules/planningReseauTempo-mutation-type';
import { CATEGORIE_LOCATION, CATEGORIE_REGROUPEMENT } from '@/configuration/catalogue/produitConf';
import getLignesCommandesWithType from '@/services/devisCommandes/ligneCommande/getLignesCommandesWithType';
import calculNombreCritere from '@/services/general/calculNombreCritere';
import PlanningSemaine from '@/components/disponibilite/disponibiliteSemaine';
import formatIsoDate from '@/services/general/formatIsoDate';
import getHeaderByWeekPlanningReseauTempo from '@/services/planningReseauTempo/headerByWeekPlanningReseauTempo';
import messageErreur from '@/services/general/messageErreur';
import { getAll } from '@/api/produit/produitLocation';
import routerLinkBlank from '@/components/general/routerLinkBlank';
import briefPlanningReseauTempo from '@/components/devisCommandes/editionDevisCommande/briefPlanningReseauTempo';
import panierPlanningReseauTempo
  from '@/components/devisCommandes/editionDevisCommande/ajoutLigneViaEcranAjout/panier/panierPlanningReseauTempo';
import TableItemsInView from '@/components/general/TableItemsInView';
import legendeReseauTempo from '@/components/planning/legendeReseauTempo';
import categorieVenteInitialize from '@/services/devisCommandes/categorieVenteInitialize';
import {
  TYPE_DEVIS,
  NORMAL,
  TYPE_COMMANDE,
  ETAT_COMMANDE_PARTIELLEMENT,
  SENS_VENTE,
  ETAT_FACTURE,
  ETAT_FACTURE_PARTIELLEMENT,
  MODULE_GESTION_COMMERCIALE,
} from '@/configuration/devisConf';
import initializeCommandeDevis from '@/services/devisCommandes/initializeCommandeDevis';
import genererDevisCommande from '@/services/devisCommandes/genererDevisCommande';
import { columnsSplice } from '@/services/general/columns';
import { ASSISTANT_COMMERCIAL, COMMERCIAL } from '@/configuration/parametrage/utilisateurConf';
import { PRODUIT_ID_LOCATION_PAR_DEFAUT, REGIE } from '@/configuration/societe/societe';
import { PARAMETRES_INTERNE_KEYS } from '@/store/modules/parametres-mutation-type';
import parametrageTable from '@/components/general/parametrageTable';
import exportExcelButton from '@/components/general/button/exportExcelButton';
import { REFERENCE_PLANNING_RESEAU_TEMPO, REFERENCE_PLANNING_AJOUT_RESEAU_TEMPO } from '@/configuration/general/referenceTableConf';
import agenceInitialize from '@/services/devisCommandes/agenceInitialize';
import jumpWeekDatePicker from '@/components/disponibilite/jumpWeekDatePicker';

const Societe = createNamespacedHelpers('societe');
const Commande = createNamespacedHelpers('commande');
const ProduitReseauTempo = createNamespacedHelpers('planningReseauTempo');
const User = createNamespacedHelpers('user');
const Parametres = createNamespacedHelpers('parametres');

export default {
  data() {
    return {
      dateDebut: null,
      permPlanning: PLANNING,
      visualisationBrief: false,
      visualisationPanier: false,
      startArrayRendering: false,
      resultPerPage: RESULTS_PER_PAGE_PLANNING,
      TYPE_DEVIS: TYPE_DEVIS,
      mountedLoadingEnd: false,
    };
  },
  components: {
    breadcrumb,
    routerLinkBlank,
    briefPlanningReseauTempo,
    panierPlanningReseauTempo,
    TableItemsInView,
    legendeReseauTempo,
    parametrageTable,
    exportExcelButton,
    PlanningSemaine,
    jumpWeekDatePicker,
  },
  computed: {
    ...User.mapGetters({
      utilisateur: 'user',
    }),
    ...Commande.mapGetters({
      commandeCourante: 'commande',
    }),
    ...Societe.mapGetters({
      societeActive: 'societeActive',
      societesInformations: 'societesInformations',
      agencesInformations: 'agencesInformations',
      agencesSelectionnees: 'agenceActive',
      societeActiveId: 'societeActiveId',
    }),
    ...ProduitReseauTempo.mapGetters({
      produits: 'produits',
      briefStocke: 'brief',
      totalProduit: 'totalProduit',
      datePlanning: 'datePlanning',
      panier: 'panier',
      afficherAnnonceur: 'afficherAnnonceur',
      getAfficherFacesAffectees: 'afficherFacesAffectees',
      boutonOption: 'boutonOption',
      boutonBloquer: 'boutonBloquer',
      boutonSelection: 'boutonSelection',
      produitsLocation: 'produitsLocation',
    }),
    ...Parametres.mapGetters({
      parametresInterne: 'parametresInterne',
    }),
    filtrerProduitParSociete() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key);
    },
    filtrerProduitParAgence() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.filtrerProduitParAgence.key);
    },
    moduleSecteurActive() {
      return this.parametresInterne(PARAMETRES_INTERNE_KEYS.moduleSecteur.key);
    },
    isPlanning() {
      return this.$route.name === 'c.bodac.planning-reseauTempo';
    },
    referenceTable() {
      return this.isPlanning
        ? REFERENCE_PLANNING_RESEAU_TEMPO : REFERENCE_PLANNING_AJOUT_RESEAU_TEMPO;
    },
    canMakeReseauPerso() {
      return !(this.commandeCourante.role !== REGIE
        || this.commandeCourante.etat === ETAT_COMMANDE_PARTIELLEMENT
        || (this.commandeCourante.type === TYPE_COMMANDE
          && (this.commandeCourante.etat === ETAT_FACTURE
            || this.commandeCourante.etat === ETAT_FACTURE_PARTIELLEMENT)));
    },
    returnValeurPanier() {
      let prix = 0;
      this.panier.forEach((ligne) => {
        ligne.lignesCommande.forEach((ligneCommande) => {
          prix += ligneCommande.totalHt && ligneCommande.typeProduit === CATEGORIE_LOCATION
            ? ligneCommande.totalHt : 0;
        });
      });
      return prix;
    },
    breadcrumb() {
      if (!this.isPlanning) return this.$route.params.breadcrumb;
      return [
        { title: this.$t('parametrage.racine'), route: this.$PAGE_DEFAULT, isActive: false },
        { title: this.$t('reseauTempo.title'), route: '', isActive: true },
      ];
    },
    nombreFiltre() {
      const banCritereKey = ['produitLocation', 'dateVisualisation', 'actif'];
      const nbCritere = calculNombreCritere(this.briefStocke, banCritereKey);
      return nbCritere > 9 ? '+9' : nbCritere;
    },
    columns() {
      const columns = ['reference', 'libelle', 'produitReseau.adresse.ville', 'agence', 'societe', 'planning'];
      if (this.societesInformations.length === 1 || this.filtrerProduitParSociete
        || this.filtrerProduitParAgence) {
        columnsSplice(columns, 'societe');
      }
      if (this.utilisateur.agences.length <= 1) {
        columnsSplice(columns, 'agence');
      }
      return columns;
    },
    options() {
      return {
        sortIcon: SORT_ICON,
        headings: {
          reference: this.$i18n.t('catalogue.table.code'),
          libelle: this.$i18n.t('catalogue.table.label'),
          'produitReseau.adresse.ville': this.$i18n.t('reseauTempo.table.ville'),
          societe: this.$i18n.t('reseauTempo.table.societe'),
          agence: this.$i18n.t('reseauTempo.table.agence'),
          planning: (h) => {
            return this.getPlanningHeader(h);
          },
        },
        filterable: false,
        perPageValues: NO_PER_PAGE_VALUE,
        perPage: this.resultPerPage,
        texts: TEXTS,
        orderBy: {
          column: 'reference',
          ascending: true,
        },
        columnsClasses: {
          ...this.columns.reduce((acc, val) => {
            acc[val] = 'sticky';
            return acc;
          }, {}),
          'produitReseau.adresse.ville': 'ellipsis planningTailleColonneVille sticky',
          libelle: 'planningTailleColonneLibelleTempo sticky',
          reference: 'planningTailleColonneReference sticky',
          societe: 'ellipsis planningTailleColonneSociete sticky',
          planning: 'planningTailleColonnePlanning sticky',
        },
        sortable: ['reference', 'produitReseau.adresse.ville', 'libelle'],
        requestFunction: ((data) => {
          if (!data.query) {
            if (this.briefStocke.agencesId === null) {
              this.briefStocke.agencesId = this.agencesSelectionnees.map(
                (agence) => agence.agenceId,
              );
            }
            data.query = cloneDeep(this.briefStocke);
            data.query.dateVisualisation = formatIsoDate(this.dateDebut);
          }
          if (this.filtrerProduitParSociete) {
            data.query.societeId = this.societeActiveId;
          }
          return this.loadReseauTempo(data);
        }),
        responseAdapter: (() => {
          return {
            data: this.produits,
            count: this.totalProduit,
          };
        }),
      };
    },
    afficherFacesAffectees: {
      get() {
        return this.getAfficherFacesAffectees;
      },
      set(value) {
        this.setAfficherFacesAffectees(value);
        this.recherche();
      },
    },
  },
  methods: {
    ...Commande.mapMutations({
      removeCommande: typesCommande.REMOVE_COMMANDE,
      setCommande: typesCommande.SET_COMMANDE,
    }),
    ...ProduitReseauTempo.mapMutations({
      clearBrief: typesProduitReseauTempo.CLEAR_BRIEF,
      clearBoutonsOptionBlocage: typesProduitReseauTempo.CLEAR_BOUTONS,
      clearPanier: typesProduitReseauTempo.CLEAR_PANIER,
      setAfficherAnnonceur: typesProduitReseauTempo.SET_AFFICHER_ANNONCEUR,
      setPanier: typesProduitReseauTempo.SET_PANIER,
      setBoutonBloquer: typesProduitReseauTempo.SET_BOUTON_BLOQUER,
      setBoutonOption: typesProduitReseauTempo.SET_BOUTON_OPTION,
      setBoutonSelection: typesProduitReseauTempo.SET_BOUTON_SELECTION,
      setProduitsLocation: typesProduitReseauTempo.SET_PRODUITS_LOCATION,
      setAfficherFacesAffectees: typesProduitReseauTempo.SET_AFFICHER_FACES_AFFECTEES,
    }),
    ...Parametres.mapActions({
      loadParametresInterne: 'loadParametresInterne',
    }),
    ...ProduitReseauTempo.mapActions({
      loadReseauTempo: 'loadReseauTempo',
      updateDatePlanning: 'updateDatePlanning',
    }),
    ...Societe.mapActions({
      loadSocietes: 'loadSocietes',
    }),
    addLigneInDevisCommande(isDevis) {
      this.clearBoutonsOptionBlocage();
      if (!this.isPlanning) return this.$router.go(-1);
      if (isDevis) return this.$router.push({ name: 'm.bodac.devis-creation' });
      this.commandeCourante.type = TYPE_COMMANDE;
      return this.$router.push({ name: 'm.bodac.commandes-ajout' });
    },
    annuler() {
      this.clearPanier();
      this.clearBrief();
      const lignesRegroupementTempo = getLignesCommandesWithType(
        this.commandeCourante.lignesCommande, CATEGORIE_REGROUPEMENT,
      );
      this.setPanier(lignesRegroupementTempo);
      this.$router.go(-1);
    },
    getLibelleSociete(societeId) {
      const societe = this.societesInformations.find((societe) => {
        return societe.id === societeId;
      });
      return societe ? societe.libelle : null;
    },
    updateDate(date) {
      this.changementPeriode(true, date);
    },
    async changementPeriode(makeRecherche, date) {
      const previousDate = date ?? this.dateDebut;
      if (!previousDate) return;
      const newDate = cloneDeep(this.datePlanning);
      newDate.dateStart = moment(previousDate).startOf('isoWeek');
      await this.updateDatePlanning(newDate);
      if (makeRecherche === true) this.recherche();
    },
    debutLoading() {
      if (this.loadingComponent) { this.loadingComponent.close(); }
      this.loadingComponent = this.$buefy.loading.open();
    },
    finLoading() {
      this.loadingComponent.close();
    },
    getPlanningHeader(h) {
      return getHeaderByWeekPlanningReseauTempo(
        h, this.datePlanning.days, this.datePlanning.dateStart, this.datePlanning.dateEnd,
      );
    },
    recherche() {
      if (this.visualisationBrief) this.visualisationBrief = !this.visualisationBrief;
      this.$refs[this.referenceTable].refresh();
    },
    async updateProduitsLocation() {
      const queryItem = {
        query: {
          numerique: false,
          societeId: this.societeActiveId,
        },
        orderBy: 'ProduitLocation.Quantite, Libelle',
        ascending: true,
        maxResultCount: NO_PAGINATION,
      };
      this.setProduitsLocation((await getAll(queryItem)).data.result.items);
      this.produitsLocation.push({ id: PRODUIT_ID_LOCATION_PAR_DEFAUT, libelle: this.$t('reseauTempo.briefContent.locationDefault') });
      if (this.societeActive.produitIdDefautRegroupement) {
        this.briefStocke.produitLocation = this.produitsLocation.find((loc) => {
          return loc.id === this.societeActive.produitIdDefautRegroupement;
        });
      }
    },
    getAgenceLibelle(agenceId) {
      const agenceFind = this.agencesInformations.find((agence) => {
        return agence.agenceId === agenceId;
      });
      if (agenceFind) return agenceFind.libelleAgence;
      return '';
    },
  },
  beforeRouteLeave(to, from, next) {
    if (!ROUTE_ALLOWED_WITHOUT_CLEAN_STORE.includes(to.name)) {
      this.removeCommande();
      this.clearPanier();
      this.clearBrief();
      this.clearBoutonsOptionBlocage();
    }
    this.finLoading();
    next();
  },
  async created() {
    window.addEventListener('resize', this.changementPeriode);
    if (!this.isPlanning && this.commandeCourante
      && this.commandeCourante.datePremierAffichage) {
      this.dateDebut = cloneDeep(this.commandeCourante.datePremierAffichage);
    } else this.dateDebut = new Date();
    await this.changementPeriode(false);
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    this.setAfficherAnnonceur(true);
    if (!this.$route.params.breadcrumb && !this.isPlanning) {
      this.removeCommande();
      this.$router.go(-1);
    }
    try {
      await this.loadSocietes({});
      await this.updateProduitsLocation();
      if (!this.isPlanning && this.commandeCourante) {
        const lignesRegroupementTempo = getLignesCommandesWithType(
          this.commandeCourante.lignesCommande, CATEGORIE_REGROUPEMENT,
        );
        lignesRegroupementTempo.forEach((ligne) => { ligne.isFromDCF = true; });
        this.setPanier(lignesRegroupementTempo);
      }
      await this.loadParametresInterne([
        PARAMETRES_INTERNE_KEYS.filtrerProduitParSociete.key,
        PARAMETRES_INTERNE_KEYS.filtrerProduitParAgence.key,
        PARAMETRES_INTERNE_KEYS.moduleSecteur.key,
      ]);
      loadingComponent.close();
      if (this.utilisateur.agences.length > 1) {
        this.briefStocke.agencesId = this.agencesSelectionnees.map((agence) => agence.agenceId);
      }
      if (!this.briefStocke.produitLocation && !this.isPlanning) this.visualisationBrief = true;
      if (this.isPlanning) {
        const commande = genererDevisCommande(
          TYPE_DEVIS, NORMAL, this.societeActive, SENS_VENTE, MODULE_GESTION_COMMERCIALE);
        agenceInitialize(commande);
        if (this.utilisateur.profil === ASSISTANT_COMMERCIAL) {
          commande.assistantId = this.utilisateur.id;
        }
        if (this.utilisateur.profil === COMMERCIAL) {
          commande.commercialId = this.utilisateur.id;
        }
        initializeCommandeDevis(commande);
        categorieVenteInitialize(commande);
        this.setCommande(commande);
      }
      if (this.moduleSecteurActive) {
        this.briefStocke.secteurIds = this.utilisateur.secteursId ?? [];
      }
      this.mountedLoadingEnd = true;
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
    this.setInformationPage(this.$t('pageGescom.planning.reseauTempo'));
  },
};

</script>
